import { FeatureResponse } from '../../client';
import { Initiative, TeamFeatureCell } from '../molecules';

interface DashboardProps {
  data: FeatureResponse[];
}

export function Dashboard({ data }: DashboardProps) {
  const sortedData = [...data].sort((a, b) => {
    const order = (s: string) => {
      switch (s) {
        case 'done':
          return 0;
        case 'in_progress':
          return 1;
        default:
          return 2;
      }
    };
    const ord = order(a.status) - order(b.status);
    if (ord !== 0) return ord;
    if (a.status === 'done') return (b.completed_at_s ?? 0) - (a.completed_at_s ?? 0);
    if (a.status === 'in_progress') return a.size - a.pending_tasks - (b.size - b.pending_tasks);
    return b.earnings_rate - a.earnings_rate;
  });

  const allTeams = new Set<string>();
  sortedData.forEach((feature) => {
    Object.keys(feature.teams).forEach((team) => allTeams.add(team));
  });
  const teamNames = Array.from(allTeams).sort();

  return (
    <div className="w-full overflow-x-auto px-4">
      <div className="border border-border-default rounded-md w-full overflow-hidden">
        <table className="w-full text-sm" style={{ tableLayout: 'auto' }}>
          <thead>
            <tr>
              <th className="min-w-[200px] w-[200px] p-2 bg-bg-elevated" />
              <th
                colSpan={teamNames.length}
                className="p-2 text-center bg-agility/20 text-agility-dark dark:text-agility-light font-semibold"
              >
                Teams
              </th>
            </tr>
            <tr>
              <th className="min-w-[200px] w-[200px] p-2 text-center bg-bg-accent-subtle text-text-accent font-semibold">
                Initiative
              </th>
              {teamNames.map((team) => (
                <th key={team} className="p-2 text-center min-w-[120px] bg-agility/10 font-medium whitespace-nowrap">
                  {team}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {sortedData.map((feature) => (
              <tr key={feature.id} className="border-t border-border-muted">
                <td className="min-w-[200px] w-[200px] bg-bg-accent-subtle">
                  <Initiative feature={feature} />
                </td>
                {teamNames.map((team) => (
                  <td key={`${feature.id}-${team}`} className="min-w-[120px] bg-agility/5">
                    <TeamFeatureCell teamData={feature.teams[team]} />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
